import { Injectable } from '@angular/core';
import { Http, XHRBackend, RequestOptions, RequestOptionsArgs, Request, Response, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { MainConfig } from '../main-config';
import { LocaleDataService } from './locale-data.service';

@Injectable()
export class HttpService extends Http {
  private apiUrl: string = '';
  private authorization: string = null;

  constructor(
    backend: XHRBackend,
    defaultOptions: RequestOptions,
    private router: Router,
    private mainConfig: MainConfig,
    private localeDataService: LocaleDataService
  ) {
    super(backend, defaultOptions);
    this.apiUrl = this.mainConfig.apiUrl;
  }

  request(request: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (typeof request === 'string') {
      if (!options) {
        options = { headers: new Headers() };
      }

      request = this.apiUrl + request;
      this.setHeaders(options);
    } else {
      request['url'] = this.apiUrl + request['url'];
      this.setHeaders(request);
    }

    const observableRequest = super
      .request(request, options)
      .catch(this.catchErrors())
    ;

    return observableRequest;
  }

  getJsonData(response: Response) {
    return response.json().data;
  }

  private setHeaders(objectToSetHeadersTo: Request | RequestOptionsArgs) {
    const headers = objectToSetHeadersTo.headers;
    const authorization = localStorage.getItem(this.mainConfig.authTokenName);

    if (!headers.get('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }
    if (!headers.get('i18n-locale')) {
      headers.set('i18n-locale', this.localeDataService.getLocale());
    }

    if (authorization !== null) {
      headers.set('Authorization', 'Bearer ' + authorization);
    }
  }

  private catchErrors() {
    return (res: Response) => {
      if (res.status === 401 || res.status === 403) {
        this.router.navigate(['login']);
      }

      return Observable.throw(res);
    };
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/services/http.service.ts